/**
 * Utilitário para mascarar valores monetários quando os saldos estão ocultos
 */

import type { CurrencyCode } from './dateUtils.ts';
import { formatCurrency } from './dateUtils.ts';

/**
 * Mascara um valor monetário, substituindo os dígitos por "•"
 * Mantém o símbolo da moeda e a formatação
 * @param value Valor monetário formatado (ex: "R$ 1.234,56") ou número
 * @param currency Código da moeda para formatação quando value é número
 * @returns Valor mascarado (ex: "R$ ••••,••")
 */
export function maskCurrency(value: string | number, currency: CurrencyCode = 'BRL'): string {
  if (typeof value === 'number') {
    value = formatCurrency(value, currency);
  }

  // Substituir todos os dígitos por "•"
  // Mantém símbolos de moeda, separadores e espaços
  return value.replace(/\d/g, '•');
}

/**
 * Mascara um valor numérico simples (sem formatação de moeda)
 * @param value Valor numérico
 * @returns String mascarada
 */
export function maskNumber(value: number): string {
  const str = value.toString();
  return str.replace(/\d/g, '•');
}

